export default "__VITE_ASSET__vtRQJq7D__"